<template>
  <v-container class="register p-0" fluid>
    <vue-headful :title="$t('header.register') + $t('title')"></vue-headful>
    <HkiaraceBannerFrame
      :src="require('../../assets/reception.jpg')"
      :label="headers[step]"
      :is-snap-content="true"
    >
      <div class="form-div">
        <v-window v-model="step">
          <v-window-item>
            <v-form ref="stepOneForm">
              <v-row>
                <v-col cols="12" md="6">
                  <v-row class="form-title title-font">{{
                    $t("register.login_info")
                  }}</v-row>
                  <v-row>
                    <v-col cols="12" sm="8" md="8" class="pt-0">
                      <v-text-field
                        outlined
                        :label="$t('register.email')"
                        :placeholder="$t('register.email')"
                        v-model="email"
                        :rules="emailRules"
                        validate-on-blur
                        autocapitalize="off"
                        :disabled="emailVerified || resendAfterSeconds > 0"
                        :append-icon="
                          emailVerified
                            ? 'mdi-check-circle'
                            : 'mdi-email-outline'
                        "
                        :append-icon-color="emailVerified ? 'success' : 'grey'"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="pt-0">
                      <v-btn
                        rounded
                        class="verify-email-btn"
                        :color="emailVerified ? 'success' : 'primary'"
                        @click="getEmailOTP"
                        :disabled="
                          emailVerified ||
                          resendAfterSeconds > 0 ||
                          !isEmailValid
                        "
                        block
                      >
                        <v-icon>{{
                          emailVerified ? "mdi-check" : "mdi-email-send"
                        }}</v-icon>
                        <span class="font-size-35 ml-2">
                          {{
                            emailVerified
                              ? $t("register.email_verified")
                              : $t("register.verify_email")
                          }}
                          <template
                            v-if="!emailVerified && resendAfterSeconds > 0"
                            >({{ resendAfterSeconds }}s)</template
                          >
                        </span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        outlined
                        :label="$t('register.mobile')"
                        :placeholder="$t('register.mobile')"
                        v-model="mobile"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        outlined
                        :label="$t('register.password')"
                        :placeholder="$t('register.password')"
                        v-model="password"
                        :rules="passwordRules"
                        validate-on-blur
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        outlined
                        :label="$t('register.confirm_password')"
                        :placeholder="$t('register.confirm_password')"
                        v-model="confirmPassword"
                        :rules="confirmPasswordRules"
                        validate-on-blur
                        :append-icon="
                          showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'
                        "
                        :type="showConfirmPassword ? 'text' : 'password'"
                        @click:append="
                          showConfirmPassword = !showConfirmPassword
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="form-title title-font">{{
                    $t("register.basic_info")
                  }}</v-row>
                  <v-row>
                    <v-col>
                      <v-combobox
                        outlined
                        :label="$t('register.salutation')"
                        :placeholder="$t('register.salutation')"
                        :items="salutationOptions"
                        v-model="salutation"
                        :rules="requiredRules"
                      ></v-combobox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="pt-0">
                      <v-text-field
                        outlined
                        :label="$t('register.surname_zh')"
                        placeholder="陳"
                        v-model="surnameZh"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pt-0">
                      <v-text-field
                        outlined
                        :label="$t('register.given_name_zh')"
                        placeholder="大文"
                        v-model="givenNameZh"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="pt-0">
                      <v-text-field
                        outlined
                        :label="$t('register.surname_en')"
                        placeholder="Chan"
                        v-model="surnameEn"
                        :rules="englishNameRules"
                        :disabled="withPrefilled"
                        validate-on-blur
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pt-0">
                      <v-text-field
                        outlined
                        :label="$t('register.given_name_en')"
                        placeholder="Tai Man"
                        v-model="givenNameEn"
                        :rules="englishNameRules"
                        :disabled="withPrefilled"
                        validate-on-blur
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-autocomplete
                        outlined
                        :label="$t('register.company')"
                        :placeholder="$t('register.company')"
                        :items="companyOptions"
                        v-model="selectedCompany"
                        :rules="companyRules"
                        clearable
                        :disabled="showOtherCompanyInput"
                        hide-details="auto"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        light
                        :label="$t('register.cannot_find_company')"
                        v-model="showOtherCompanyInput"
                        hide-details="auto"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row v-if="showOtherCompanyInput">
                    <v-col>
                      <v-text-field
                        outlined
                        :label="$t('register.other_company_name')"
                        :placeholder="$t('register.other_company_name')"
                        v-model="otherCompanyName"
                        :rules="requiredRules"
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="form-title title-font">{{
                    $t("register.sasv_info")
                  }}</v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        outlined
                        :label="$t('register.octopus_no')"
                        placeholder="123456789"
                        v-model="octopusNo"
                        v-mask="'########?#?#'"
                        :rules="octopusNoRules"
                        :disabled="withPrefilled"
                        :hint="$t('register.octopus_no_hint')"
                        persistent-hint
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-checkbox
                    light
                    v-model="acceptTnc"
                    :rules="[(value) => !!value || $t('register.require_tnc')]"
                    @click.stop="showTnc"
                    validate-on-blur
                  >
                    <template v-slot:label>
                      <div @click.stop="showTnc">{{ $t("register.tnc") }}</div>
                    </template>
                  </v-checkbox>
                  <v-checkbox light v-model="receivePromotionalEmail">
                    <template v-slot:label>
                      <div>
                        {{ $t("my_account.receive_promotional_email") }}
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                  <v-input
                    :rules="[
                      (value) => !!value || $t('register.require_captcha'),
                    ]"
                    v-model="gCaptchaResponse"
                  >
                    <VueRecaptcha
                      ref="recaptcha"
                      sitekey="6LcWt7IUAAAAABME-H9-LYoOsynOYo34NHU7ur2y"
                      :loadRecaptchaScript="false"
                      @verify="recaptchaVerified"
                      @expired="gCaptchaResponse = null"
                      size="150px"
                    ></VueRecaptcha>
                  </v-input>
                </v-col>
              </v-row>
            </v-form>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  dark
                  rounded
                  x-large
                  :color="emailVerified ? 'primary' : 'grey'"
                  class="function-button"
                  @click="
                    emailVerified &&
                      $refs.stepOneForm.validate() &&
                      finishStepOne()
                  "
                >
                  {{ $t("next") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-window-item>
          <v-window-item>
            <v-form ref="sasvForm">
              <v-row>
                <v-col>
                  <v-text-field
                    readonly
                    :label="$t('register.name')"
                    :placeholder="$t('register.name')"
                    v-model="sasvName"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    readonly
                    :label="$t('register.octopus_no')"
                    placeholder="123456789"
                    v-model="octopusNo"
                    :hint="$t('register.octopus_no_hint')"
                    persistent-hint
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-radio-group v-model="idType" column :rules="requiredRules">
                    <v-radio
                      value="AIRPORT_OCTOPUS"
                      :label="$t('id_type.AIRPORT_OCTOPUS')"
                    ></v-radio>
                    <!--                    <v-radio value="PERSONAL_OCTOPUS_AND_STAFF_CARD"-->
                    <!--                             :label="$t('id_type.PERSONAL_OCTOPUS_AND_STAFF_CARD')"></v-radio>-->
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-input :rules="requiredRules" v-model="octopusFront">
                    <v-container fluid class="flex-column pa-0">
                      <legend class="v-label theme--light">
                        {{ $t("register.octopus_front") }}
                      </legend>
                      <PhotoPreviewInput
                        v-model="octopusFront"
                        div-class="octopus-front"
                        file-name="octopus-front"
                      ></PhotoPreviewInput>
                    </v-container>
                  </v-input>
                </v-col>
                <v-col>
                  <v-input :rules="requiredRules" v-model="octopusBack">
                    <v-container fluid class="flex-column pa-0">
                      <legend class="v-label theme--light">
                        {{ $t("register.octopus_back") }}
                      </legend>
                      <PhotoPreviewInput
                        v-model="octopusBack"
                        div-class="octopus-back"
                        file-name="octopus-back"
                      ></PhotoPreviewInput>
                    </v-container>
                  </v-input>
                </v-col>
              </v-row>
              <v-row v-if="idType === 'PERSONAL_OCTOPUS_AND_STAFF_CARD'">
                <v-col>
                  <v-input :rules="requiredRules" v-model="staffCardFront">
                    <v-container fluid class="flex-column pa-0">
                      <legend class="v-label theme--light">
                        {{ $t("register.staff_card_front") }}
                      </legend>
                      <PhotoPreviewInput
                        v-model="staffCardFront"
                        div-class="staff-card-front"
                        file-name="staff-card-front"
                      ></PhotoPreviewInput>
                    </v-container>
                  </v-input>
                </v-col>
                <v-col>
                  <v-input :rules="requiredRules" v-model="staffCardBack">
                    <v-container fluid class="flex-column pa-0">
                      <legend class="v-label theme--light">
                        {{ $t("register.staff_card_back") }}
                      </legend>
                      <PhotoPreviewInput
                        v-model="staffCardBack"
                        div-class="staff-card-back"
                        file-name="staff-card-back"
                      ></PhotoPreviewInput>
                    </v-container>
                  </v-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-input :rules="requiredRules" v-model="gCaptchaResponse">
                    <VueRecaptcha
                      ref="recaptcha"
                      sitekey="6LcWt7IUAAAAABME-H9-LYoOsynOYo34NHU7ur2y"
                      :loadRecaptchaScript="false"
                      @verify="recaptchaVerified"
                      @expired="gCaptchaResponse = null"
                      size="150px"
                    ></VueRecaptcha>
                  </v-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <v-btn
                    dark
                    color="primary"
                    rounded
                    x-large
                    @click="$refs.sasvForm.validate() && submitSasv()"
                  >
                    {{ $t("submit") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-window-item>
          <v-window-item>
            <SasvStatus
              :sasv="submittedSasv"
              v-if="submittedSasv && submittedSasv.status !== 'APPROVED'"
              max-width="400px"
            ></SasvStatus>

            <v-container
              v-if="submittedSasv && submittedSasv.status === 'APPROVED'"
            >
              <v-row>
                <v-col class="title-font text-center">
                  {{ $t("register.registration_complete_details") }}
                </v-col>
              </v-row>
            </v-container>

            <v-row>
              <v-col>
                <v-btn
                  dark
                  color="primary"
                  rounded
                  x-large
                  class="register-btn function-button"
                  @click="$router.push({ name: 'home' })"
                >
                  {{ $t("register.back_to_home") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-window-item>
        </v-window>
      </div>

      <v-row
        class="register-complete text-left"
        v-if="submittedSasv && submittedSasv.status === 'APPROVED'"
        :no-gutters="pageWidth > 600"
      >
        <v-col class="canteen-col" cols="12" sm="6">
          <div
            class="canteen-banner"
            :style="
              'height:' +
              (pageWidth > 1800
                ? pageWidth / 28
                : pageWidth > 1600
                ? pageWidth / 26
                : pageWidth > 1400
                ? pageWidth / 24
                : pageWidth > 1200
                ? pageWidth / 22
                : pageWidth / 61 + 30) +
              'vh'
            "
          ></div>
          <div class="canteen-description-wrapper">
            <v-container fluid class="canteen-description-content">
              <v-row>
                <v-col class="title canteen-title">
                  {{ $t("register.canteen_upsell") }}
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <a :href="`/register?locale=${$i18n.locale}`" target="_blank">
                    <v-btn rounded color="primary"
                      >{{ $t("register.canteen_btn") }}
                    </v-btn>
                  </a>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
        <v-col class="aca-col" cols="12" sm="6">
          <div
            class="aca-banner"
            :style="
              'height:' +
              (pageWidth > 1800
                ? pageWidth / 28
                : pageWidth > 1600
                ? pageWidth / 26
                : pageWidth > 1400
                ? pageWidth / 24
                : pageWidth > 1200
                ? pageWidth / 22
                : pageWidth / 61 + 30) +
              'vh'
            "
          >
            <div class="aca-hand"></div>
          </div>

          <div class="aca-description-wrapper">
            <v-container fluid class="aca-description-content">
              <v-row>
                <v-col class="title aca-title">
                  {{ $t("register.aca") }}
                </v-col>
              </v-row>
              <v-row class="aca-subtitle">
                <v-col>
                  {{ $t("register.aca_subtitle") }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.hkgcommunity&hl=zh_HK&gl=US"
                    target="_blank"
                  >
                    <v-img
                      :src="require('@/assets/google_play.png')"
                      contain
                      width="150px"
                      class="my-4"
                    ></v-img>
                  </a>
                </v-col>
                <v-col cols="12">
                  <a
                    href="https://apps.apple.com/hk/app/hkg-community/id1495936143?l=en"
                    target="_blank"
                  >
                    <v-img
                      :src="require('@/assets/app_store.png')"
                      contain
                      width="150px"
                    ></v-img>
                  </a>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </HkiaraceBannerFrame>

    <v-dialog v-model="tncDialogShown" scrollable>
      <v-card light v-if="tnc">
        <v-card-title class="tnc-title title-font">{{
          tnc.title
        }}</v-card-title>

        <v-card-text
          @scroll="onTncScroll"
          v-html="tnc.content"
          class="text-left"
        ></v-card-text>

        <v-card-actions class="tnc-actions">
          <v-spacer></v-spacer>
          <span v-if="!tncScrolledToBottom">{{
            $t("booking.tnc_scroll_to_bottom")
          }}</span>
          <v-spacer></v-spacer>

          <!--          <v-btn text-->
          <!--                 :disabled="!tncScrolledToBottom"-->
          <!--                 class="tnc-action title-font"-->
          <!--                 @click="setAcceptTnc(false)">-->
          <!--            {{ $t('register.disagree') }}-->
          <!--          </v-btn>-->

          <!--          <v-btn text-->
          <!--                 :disabled="!tncScrolledToBottom"-->
          <!--                 class="tnc-action title-font"-->
          <!--                 color="rgb(142, 118, 91)"-->
          <!--                 @click="setAcceptTnc(true)">-->
          <!--            {{ $t('register.agree') }}-->
          <!--          </v-btn>-->

          <v-btn
            text
            class="tnc-action title-font"
            @click="setAcceptTnc(false)"
          >
            {{ $t("register.disagree") }}
          </v-btn>

          <v-btn
            text
            class="tnc-action title-font"
            color="rgb(142, 118, 91)"
            @click="setAcceptTnc(true)"
          >
            {{ $t("register.agree") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "@vue/composition-api";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { DateTime } from "luxon";
import HkiaraceBannerFrame from "../../components/HkiaraceBannerFrame";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";
import VueRecaptcha from "vue-recaptcha";
import SasvStatus from "@/components/sasv/SasvStatus";
import _ from "lodash";
import HkiaraceRegistrationEmailModal from "@/components/hkiarace/HkiaraceRegistrationEmailModal.vue";

library.add(faCheck, faTimes);

export default {
  name: "SasvRegister",
  components: {
    SasvStatus,
    PhotoPreviewInput,
    HkiaraceBannerFrame,
    VueRecaptcha,
  },
  setup(props, { root }) {
    const headers = ref([
      root.$t("header.register"),
      root.$t("id_verification.title"),
      root.$t("register.review"),
      root.$t("register.complete"),
    ]);
    const step = ref(0);
    watch(
      () => step.value,
      () => {
        setTimeout(() => {
          root.$vuetify.goTo(".hkiarace-banner-frame", {
            easing: "easeInOutCubic",
          });
        }, 400);
      }
    );

    const requiredRules = ref([
      (value) => !!value || root.$t("register.enter_required_field"),
    ]);

    const pageWidth = computed(() => root.$vuetify.breakpoint.width);

    const withPrefilled = ref(false);
    const prefilledCompanyId = ref(null);

    // Step 1
    const email = ref(null);
    const EMAIL_REGEX =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isEmailValid = computed(
      () => !!email.value && EMAIL_REGEX.test(email.value)
    );
    const emailRules = ref([
      (value) => EMAIL_REGEX.test(value) || root.$t("register.invalid_email"),
      () =>
        emailVerified.value || root.$t("register.email_verification_required"),
    ]);

    const mobile = ref(null);

    const password = ref(null);
    const passwordRules = ref([
      (value) =>
        (!!value && value.length >= 8) ||
        root.$t("register.password_contain_eight_characters"),
      (value) =>
        (!!value && !!value.match(/[A-Za-z]/g)) ||
        root.$t("register.password_contain_letters"),
      (value) =>
        (!!value && !!value.match(/[0-9]/g)) ||
        root.$t("register.password_contain_numbers"),
      (value) =>
        (!!value &&
          !!value.match(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g) &&
          !value.match(/[ ]/g)) ||
        root.$t("register.password_contain_special_characters"),
    ]);
    const showPassword = ref(false);

    const confirmPassword = ref(null);
    const confirmPasswordRules = ref([
      (value) =>
        (!!password.value && value === password.value) ||
        root.$t("register.password_match"),
    ]);
    const showConfirmPassword = ref(false);

    const salutation = ref(null);
    const salutationOptions = ref([
      { value: "mr", text: root.$t("salutation.mr") },
      { value: "mrs", text: root.$t("salutation.mrs") },
      { value: "ms", text: root.$t("salutation.ms") },
      { value: "dr", text: root.$t("salutation.dr") },
    ]);

    const surnameEn = ref("");
    const givenNameEn = ref("");
    const englishNameRules = ref([
      ...requiredRules.value,
      (value) =>
        !!/^[a-zA-Z ]*$/g.test(value) ||
        root.$t("register.only_input_english_characters"),
    ]);

    const surnameZh = ref("");
    const givenNameZh = ref("");

    const selectedCompany = ref(null);
    const companyRules = computed(() => [
      (value) =>
        showOtherCompanyInput.value ||
        !!value ||
        root.$t("register.select_company"),
    ]);
    const showOtherCompanyInput = ref(false);
    const otherCompanyName = ref("");
    const companies = ref([]);
    const getCompanies = async function () {
      root.$callAPI(
        "hkiarace/company/",
        {
          page_size: -1,
        },
        function (response) {
          companies.value = response.body.companies;

          if (prefilledCompanyId.value) {
            selectedCompany.value = _.find(companies.value, {
              id: prefilledCompanyId.value,
            });
          }
        }
      );
    };
    const companyOptions = computed(() => {
      return companies.value.map((c) => {
        return { text: c.name_en + " - " + c.name_zh, value: c };
      });
    });

    const octopusNo = ref(null);
    const octopusNoRules = ref([
      (value) => !!value || root.$t("register.enter_required_field"),
      (value) =>
        !!/^[0-9]{8,10}$/g.test(value) ||
        root.$t("register.incorrect_octopus_no"),
    ]);

    const receivePromotionalEmail = ref(true);

    // Registration session data
    const registrationSessionId = ref(null);
    const emailVerified = ref(false);
    const verifiedEmail = ref(null); // Store the verified email

    // Cooldown shared with the email modal so that closing the modal
    // does not let the user immediately re-trigger /registration/start/.
    const resendAfterSeconds = ref(0);
    const resendCountdownInterval = ref(null);
    const startCooldown = function (resendAfterIso) {
      if (!resendAfterIso) return;
      if (resendCountdownInterval.value) {
        clearInterval(resendCountdownInterval.value);
        resendCountdownInterval.value = null;
      }
      const target = DateTime.fromISO(resendAfterIso);
      resendAfterSeconds.value = Math.max(
        0,
        Math.ceil(target.diffNow("seconds").seconds)
      );
      if (resendAfterSeconds.value <= 0) return;
      resendCountdownInterval.value = setInterval(() => {
        resendAfterSeconds.value = Math.max(
          0,
          Math.ceil(target.diffNow("seconds").seconds)
        );
        if (resendAfterSeconds.value <= 0) {
          clearInterval(resendCountdownInterval.value);
          resendCountdownInterval.value = null;
        }
      }, 1000);
    };
    const clearCooldown = function () {
      if (resendCountdownInterval.value) {
        clearInterval(resendCountdownInterval.value);
        resendCountdownInterval.value = null;
      }
      resendAfterSeconds.value = 0;
    };

    // Watch for email changes to reset verification
    watch(
      () => email.value,
      (newEmail, oldEmail) => {
        if (newEmail !== verifiedEmail.value && emailVerified.value) {
          emailVerified.value = false;
          registrationSessionId.value = null;
          verifiedEmail.value = null;
        }
        // Different email = different rate-limit bucket; drop local timer.
        clearCooldown();
      }
    );

    // Get Email OTP
    const getEmailOTP = async function () {
      if (resendAfterSeconds.value > 0 || !isEmailValid.value) return;
      const result = await root.$dialog.showAndWait(
        HkiaraceRegistrationEmailModal,
        {
          showClose: false,
          persistent: true,
          initialEmail: email.value,
          onUpdateResendAfter: (iso) => startCooldown(iso),
        }
      );

      if (result && result.success) {
        registrationSessionId.value = result.sessionId;
        email.value = result.email;
        emailVerified.value = true;
        verifiedEmail.value = result.email; // Store the verified email
        clearCooldown();
      }
    };

    const finishStepOne = function () {
      if (!emailVerified.value) return;

      const params = {
        session_id: registrationSessionId.value,
        sasv_credentials: {
          octopus_no: octopusNo.value,
          surname: surnameEn.value,
          given_name: givenNameEn.value,
          company_id: showOtherCompanyInput.value
            ? null
            : selectedCompany.value && selectedCompany.value.id,
          other_company_name: otherCompanyName.value,
          id_type: idType.value,
        },
        user_details: {
          salutation: salutation.value.value,
          surname_en: surnameEn.value,
          given_name_en: givenNameEn.value,
          surname_zh: surnameZh.value,
          given_name_zh: givenNameZh.value,
          mobile: mobile.value,
          receive_promotional_email: receivePromotionalEmail.value,
          password: password.value,
        },
        g_captcha_response: gCaptchaResponse.value,
      };

      root.$callAPI(
        "hkiarace/registration/submit-details/",
        params,
        function (response) {
          if (response.body && response.body.success) {
            submittedSasv.value = response.body.sasv;
            const nextStep = response.body.next_step;
            if (nextStep === "sasv_image_submission") {
              step.value = 1;
            } else if (nextStep === "finalize") {
              // SASV already approved — finalize to create account
              finalizeRegistration();
            }
          }
        },
        function (error) {
          gCaptchaResponse.value = null;
          recaptcha.value.reset();
          if (
            error &&
            error.body &&
            error.body.code === "account_exists_contact_support"
          ) {
            // Person already holds a HKIARaCE account: show the contact
            // message and return to the home page on close.
            root.$showAlertMessage(
              root.$t("register.account_exists_contact_support"),
              () => root.$router.push({ name: "home" })
            );
          } else if (error && error.body && error.body.msg) {
            root.$showAlertMessage(error.body.msg);
          } else {
            root.$showAlertMessage(root.$t("error_messages.default"));
          }
        }
      );
    };

    // Step 2
    const submittedSasv = ref(null);
    const sasvName = computed(() => {
      return `${surnameEn.value.toUpperCase().trim()} ${givenNameEn.value
        .toUpperCase()
        .trim()}`;
    });

    const finalizeRegistration = function () {
      root.$callAPI(
        "hkiarace/registration/finalize/",
        {
          session_id: registrationSessionId.value,
        },
        function (response) {
          if (response.body && response.body.success) {
            submittedSasv.value = response.body.sasv;
            step.value = 2;
          }
        },
        function (error) {
          if (error && error.body && error.body.msg) {
            root.$showAlertMessage(error.body.msg);
          } else {
            root.$showAlertMessage(root.$t("error_messages.default"));
          }
        }
      );
    };

    const idType = ref("AIRPORT_OCTOPUS");
    const octopusFront = ref(null);
    const octopusBack = ref(null);
    const staffCardFront = ref(null);
    const staffCardBack = ref(null);

    const submitSasv = async function () {
      const params = {
        g_captcha_response: gCaptchaResponse.value,
        surname: surnameEn.value,
        given_name: givenNameEn.value,
        octopus_no: octopusNo.value,
        company_id: showOtherCompanyInput.value
          ? null
          : selectedCompany.value && selectedCompany.value.id,
        other_company_name: showOtherCompanyInput.value
          ? otherCompanyName.value
          : null,
        id_type: idType.value,
        octopus_front: await root.$convertFileToBase64(octopusFront.value),
        octopus_back: await root.$convertFileToBase64(octopusBack.value),
        staff_card_front:
          idType.value === "PERSONAL_OCTOPUS_AND_STAFF_CARD"
            ? await root.$convertFileToBase64(staffCardFront.value)
            : null,
        staff_card_back:
          idType.value === "PERSONAL_OCTOPUS_AND_STAFF_CARD"
            ? await root.$convertFileToBase64(staffCardBack.value)
            : null,
        source: "HKIASC",
      };

      root.$callAPI(
        "sasv/init/",
        params,
        function (response) {
          if (response.body.ocr_fail) {
            octopusFront.value = null;
            octopusBack.value = null;
            staffCardFront.value = null;
            staffCardBack.value = null;
            root.$showAlertMessage(root.$t("register.ocr_fail_msg"));
          } else {
            submittedSasv.value = response.body.sasv;
            finalizeRegistration();
          }
        },
        function (error) {
          if (error && error.body && error.body.msg) {
            root.$showAlertMessage(error.body.msg);
          } else {
            root.$showAlertMessage(root.$t("error_messages.default"));
          }
        }
      );

      gCaptchaResponse.value = null;
      recaptcha.value.reset();
    };

    // TNC
    const acceptTnc = ref(false);
    const tnc = ref(null);
    const tncDialogShown = ref(false);
    const getTNC = function () {
      root.$callAPI("hkiarace/tnc/", {}, function (response) {
        tnc.value = response.body;
      });
    };
    const showTnc = function (e) {
      e.preventDefault();

      if (!acceptTnc.value) {
        tncDialogShown.value = true;
      } else {
        acceptTnc.value = false;
      }
    };
    const tncScrolledToBottom = ref(false);
    const onTncScroll = function ({
      target: { scrollTop, clientHeight, scrollHeight },
    }) {
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.tncScrolledToBottom = true;
      }
    };
    const setAcceptTnc = function (accept) {
      tncDialogShown.value = false;
      acceptTnc.value = accept;
    };

    // ReCaptcha
    const loadRecaptcha = function () {
      const url = `https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=${
        root.$i18n.locale === "en" ? "en" : "zh-TW"
      }`;
      const $el = document.createElement("script");
      $el.src = url;
      $el.async = true;
      document.head.appendChild($el);
    };
    const recaptcha = ref(null);
    const gCaptchaResponse = ref(null);
    const recaptchaVerified = function (response) {
      gCaptchaResponse.value = response;
    };

    onMounted(() => {
      // Check prefilled data
      const p = root.$route.query.p;
      if (p) {
        const prefilled = JSON.parse(atob(p));
        withPrefilled.value = true;
        octopusNo.value = prefilled.octopusNo;
        surnameEn.value = prefilled.surname;
        givenNameEn.value = prefilled.givenName;
        prefilledCompanyId.value = prefilled.company_id;
      }

      getTNC();
      getCompanies();
      loadRecaptcha();
    });

    onBeforeUnmount(() => {
      if (resendCountdownInterval.value) {
        clearInterval(resendCountdownInterval.value);
      }
    });

    return {
      headers,
      step,
      requiredRules,
      pageWidth,
      withPrefilled,

      // Step 1
      email,
      emailRules,
      isEmailValid,

      mobile,

      password,
      passwordRules,
      showPassword,

      confirmPassword,
      confirmPasswordRules,
      showConfirmPassword,

      salutation,
      salutationOptions,

      surnameEn,
      givenNameEn,
      englishNameRules,

      surnameZh,
      givenNameZh,

      selectedCompany,
      companyRules,
      showOtherCompanyInput,
      otherCompanyName,
      companyOptions,

      octopusNo,
      octopusNoRules,

      receivePromotionalEmail,

      registrationSessionId,
      emailVerified,
      verifiedEmail,
      getEmailOTP,
      resendAfterSeconds,

      finishStepOne,

      // Step 2
      submittedSasv,
      sasvName,

      idType,
      octopusFront,
      octopusBack,
      staffCardFront,
      staffCardBack,

      submitSasv,

      // TNC
      tnc,
      tncDialogShown,
      showTnc,
      acceptTnc,
      onTncScroll,
      tncScrolledToBottom,
      setAcceptTnc,

      // ReCaptcha
      recaptcha,
      recaptchaVerified,
      gCaptchaResponse,
    };
  },
};
</script>

<style lang="less">
.register {
  position: relative;

  .form-div {
    padding: 16px 10% 24px 10%;
    background-color: white;

    .form-title {
      font-size: 1.5rem;
      padding-top: 32px;
      padding-bottom: 16px;
      padding-left: 12px;
    }

    .v-input {
      border-radius: 0;
    }

    .v-radio {
      .v-label {
        margin-bottom: 0rem;
      }
    }

    .v-text-field__slot {
      .v-label {
        background-color: white;
        padding-left: 4px;
        padding-right: 4px;
      }
    }
  }

  .verify-email-btn.v-btn {
    width: 100% !important;
    height: 56px !important;
    margin-top: 0;
    padding-top: 4px !important;
    padding-right: 16px !important;
    padding-bottom: 4px !important;
    padding-left: 16px !important;

    .v-btn__content {
      flex-wrap: wrap;
      max-width: 100%;
      white-space: normal;
      word-break: break-word;
      line-height: 1.1;
    }
  }

  .photo-preview-input-div {
    &::before {
      content: "";
      opacity: 0.15;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: absolute;
    }

    &.staff-card-front::before {
      background: url("../../assets/ara-front.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    &.staff-card-back::before {
      background: url("../../assets/ara-back.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    &.octopus-front::before {
      background: url("../../assets/octopus-front.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    &.octopus-back::before {
      background: url("../../assets/octopus-back.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}

.register-complete {
  .canteen-col {
    position: relative;
  }

  .canteen-banner {
    background-image: url("../../assets/acc.jpg");
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;

    width: 100%;
    // padding-top: 48%;
    height: 20vh;
    overflow: hidden;
  }

  .canteen-description-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-family: "Montserrat", "PingFang TC", "Heiti TC", "微軟正黑體",
      "Microsoft JhengHei", "sans-serif" !important;

    .canteen-description-content {
      flex: 0 0 auto;
      width: 100% !important;
      position: relative;
      background-color: rgb(220, 216, 210);

      .canteen-title {
        color: var(--v-secondary-darken4);
      }
    }

    @media only screen and (min-width: 600px) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100% !important;
      height: 50%;
      display: flex;
      align-items: start;

      .canteen-description-content {
        background-color: rgba(255, 255, 255, 0.85);
        width: 100%;
        padding: 10% 5% 10% 10%;
        //padding: 32px;
      }
    }
  }

  .aca-col {
    position: relative;
  }

  .aca-banner {
    position: relative;
    background-color: #f7f7f7;

    width: 100%;
    // padding-top: 48%;
    overflow: hidden;
  }

  .aca-hand {
    background-image: url("../../assets/aca_hand.png");
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;

    position: absolute;
    bottom: 0;
    right: 0;
    width: 80%;
    height: 100%;
  }

  .aca-description-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 60% !important;
    height: 100%;
    display: flex;
    align-items: start;
    justify-content: center;
    color: white;
    font-family: "Montserrat", "PingFang TC", "Heiti TC", "微軟正黑體",
      "Microsoft JhengHei", "sans-serif" !important;

    .aca-description-content {
      background-color: transparent;
      width: 100%;
      padding: 10% 5% 10% 10%;
      flex: 0 0 auto;
      position: relative;

      .aca-subtitle {
        color: var(--v-secondary-darken4);
        font-size: 0.8rem;
      }

      .aca-title {
        color: var(--v-secondary-darken4);
      }
    }
  }
}

.text-red {
  color: red;
}

@media only screen and (min-width: 600px) {
  .form-div {
    top: calc(20% - 5rem) !important;
  }
}

@media only screen and (min-width: 820px) {
  .form-div {
    top: calc(20% - 10rem) !important;
  }
}

@media only screen and (min-width: 960px) {
  .form-div {
    top: calc(20%) !important;
  }
}

@media only screen and (min-width: 1248px) {
  .form-div {
    top: calc(20% + 5rem) !important;
  }
}
</style>
